export const WORKFLOW_PROJECT_ID = process.env.REACT_APP_WORKFLOW_PROJECT_ID
export const API_HOST= process.env.REACT_APP_API_HOST